import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import ConfigurationApiService from '@lib/api-services/ConfigurationAPIService';
import TWSProjectApiService from '@lib/api-services/TWSProjectApiService';
import buildResourcePath from '@lib/buildResourcePath';
import UIServicesRegistry from '@lib/ui-services/UIServicesRegistry';
import XMessageUIService from '@lib/ui-services/XMessageUIService';
import { observer } from 'mobx-react';
import React from 'react';
import ProjectStore from '../../../store/projectStore';
import IndexTableFeature from '../../index-table/IndexTableFeature';
import AddConfigurationDropdown from './../../project/AddConfigurationDropdown';
import ProjectConfigurationsIndexTable from './../../project/ProjectConfigurationsIndexTable';
import Loader from '../../common/Loader';
import Warning from '../../common/Warning';

interface SelfProps {
    canSetConfigurationOptional: boolean;
    isViewer: boolean;
    canAddCalculation: boolean;
}

const TWSProjectCalculations = observer(
    class TWSProjectCalculations extends React.Component<SelfProps> {

        state = {
            manuallyChangedRows: {},
            manuallyAddedRows: [],
            deleteModalIsOpen: false
        }

        addConfigurationOptions;
        xMessageUIService: any;
        configurationApiService: any;
        projectApiService: any;

        onProductSerialNumberChanged: any;
        onOptionGroupNameChange: any;

        constructor(props: any) {
            super(props)

            this.addConfigurationOptions = [
                { id: 0, label: __('Add new calculation') },
            ]

            window.scheduleAtDocumentReady(() => {
                this.xMessageUIService = UIServicesRegistry.getService(XMessageUIService)
                this.configurationApiService = APIServicesRegistry.getService(ConfigurationApiService)
                this.projectApiService = APIServicesRegistry.getService(TWSProjectApiService)
            })
        }

        addCalculationOptionClick = (option: { id: number; }) => {
            if (option.id === 0) {
                this.addNewCalculationClick()
            }
        }

        addNewCalculationClick() {
            if (ProjectStore.isNew()) {
                this.xMessageUIService.pushNotification({
                    type: 'info',
                    title: __('Info'),
                    text: __('Before adding new calculation you must save project.'),
                    timeout: 5
                });
            } else {
                window.location.href = buildResourcePath(`TWSCalculation/CreateCalculation?projectId=${ProjectStore.formModel.id.value}`)
            }
        }

        onRemoveRowClick = (guid: any) => {
            let manuallyChangedRows = this.state.manuallyChangedRows as any;
            var item = ProjectStore.formModel.calculations.items.find((x: any) => x.guid === guid);
            delete manuallyChangedRows[item.id];

            ProjectStore.updateCalculationItems(ProjectStore.formModel.calculations.items.filter((x: any) => x.guid != guid))
            ProjectStore.setConfigurationIsValid(true);
            ProjectStore.setDirty(true);
            this.setState({
                manuallyChangedRows: manuallyChangedRows
            })
        }

        copyRow(guid: any, requestAction: string) {
            var model = ProjectStore.getTransformedFormModel()
            var data = {
                guid: guid,
                projectId: ProjectStore.formModel.id.value,
                items: model.calculations,
            }

            this.projectApiService[requestAction](data).then((response: any) => {
                if (!response.data) {
                    ProjectStore.setConfigurationIsValid(false);
                    ProjectStore.duringEditConfigurations = false;
                    return;
                }

                if (response.data.items.items.length)
                    ProjectStore.setDirty(true);

                ProjectStore.updateCalculationItems(response.data.items.items);
                ProjectStore.duringEditConfigurations = false;
            })
        }

        onCopyRowClick = (guid: any) => {
            this.copyRow(guid, 'copyCalculation');
        }

        onCopyAsOptionalRowClick = (guid: any) => {
        }

        onRootCheckboxToggled = (manuallyChangedRows: any) => {
            this.setState({
                manuallyChangedRows
            })
        }

        onRowCheckboxToggled = (manuallyChangedRows: any) => {
            this.setState({
                manuallyChangedRows
            })
        }

        onConfiguratioRowPriceChanged = (name: any, guid: any, value: any) => {
        }

        onOptionSelectClick = (row: any) => {
        }


        render() {
            let columns = ProjectStore.formModel.calculations.columns;
            let items = ProjectStore.formModel.calculations.items.toJS();
            let options = {
                rowButtons: ProjectStore.formModel.calculations.rowButtons.toJS(),
                onConfiguratioRowPriceChanged: this.onConfiguratioRowPriceChanged,
                onProductSerialNumberChanged: this.onProductSerialNumberChanged,
                onOptionSelectClick: this.onOptionSelectClick,
                onOptionGroupNameChange: this.onOptionGroupNameChange
            }

            const getIndexTableProps = () => {

                var props: any = {
                    projectId: ProjectStore.formModel.id.value,
                    results: items,
                    columns: columns,
                    options: options,
                    onRemoveRowClick: this.onRemoveRowClick,
                    canSetConfigurationOptional: this.props.canSetConfigurationOptional,
                    onCopyRowClick: this.onCopyRowClick,
                    onCopyAsOptionalRowClick: this.onCopyAsOptionalRowClick,
                    features: []
                }

                if (options.rowButtons.some((x: any) => x.slug === 'Edit')) {
                    props.features.push(IndexTableFeature.NamesAsEditPageLinks);
                }
                if (options.rowButtons.some((x: any) => x.slug === 'Edit') && options.rowButtons.length > 1) {
                    props.features.push(IndexTableFeature.ActionButtons);
                }

                return props;
            }

            return (
                <div style={{ position: 'relative' }}>
                    {ProjectStore.duringEditConfigurations && <Loader fillContainer={true} />}
                    <div className="project-calculations-section flex-center-v flex-space-between">
                        <h3>{__('Calculations')}</h3>
                        <div className="add-configuration-options page-body-action-buttons">
                            <span className="desktop-only">
                                {this.props.canAddCalculation && <AddConfigurationDropdown
                                    items={this.addConfigurationOptions}
                                    caption={__('Add calculation')}
                                    onItemClick={this.addCalculationOptionClick}
                                />}
                                {this.props.isViewer &&
                                    <Warning warning={{ color: 'orange', text: 'As viewer you can not edit the calculations', isStatic: true }} />
                                }
                            </span>
                        </div>
                    </div>

                    {ProjectStore.formModel.calculations.items.length > 0 && (
                        <React.Fragment>
                            <div className="project-calculations-table responsive-table-container">
                                <ProjectConfigurationsIndexTable {...getIndexTableProps()} />
                            </div>
                        </React.Fragment>
                    )}
                </div>
            );
        }

        areFooterActionButtonsDisabled() {
            return Object.entries(this.state.manuallyChangedRows).filter(([k, v]) => v === true).length === 0
        }

    }
)

export default TWSProjectCalculations;